import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SortAlV1Component} from './sort-by-al-v1.component'



@NgModule({
  declarations: [SortAlV1Component],
  exports: [
    SortAlV1Component,
  ],
  imports: [
    CommonModule,
  ],
  providers: []
})
export class SortByAlV1Module { }
